import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageBanner({ title, subtitle, crumb, image }) {
  return (
    <section className="relative pt-40 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f2740]/95 via-[#0f2740]/82 to-[#0f2740]/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f2740]/70 to-transparent" />
      </div>
      <div className="container-x relative z-10">
        <div className="flex items-center gap-2 text-sm text-[#a9c6dd] mb-4">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-white">{crumb}</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mb-4">{title}</h1>
        {subtitle && <p className="text-white/75 text-lg max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
